<script setup lang="ts">
import { ref } from "vue";
import { NInput, NButton, NDivider, NForm, NFormItem, NIcon, NText, FormInst } from 'naive-ui'
import { Google as GoogleIcon } from '@vicons/fa'
import { loginRules } from "@/ts/formValidationRules"

import { useAuthLoginStore } from "@/stores/auth/login.store";

const authLoginStore = useAuthLoginStore()

const formRef = ref<FormInst | null>(null)

const formData = ref<{ email: string, password: string }>({
  email: '',
  password: ''
})

const handleLogin = () => {
  formRef.value?.validate((errors) => {
    if (!errors) {
      authLoginStore.login(formData.value)
    }
  })
}

const validationStatus = (value : number) => value === 2 ? 'error' : 'success';

const errorMessage = (value : number, field : string) => {
  if(value === 2) {
    return (authLoginStore.errors?.errors?.[field] ?? []).shift()
  }

  return '';
}

</script>

<template>
  <div class="sign-up-form">
    <!-- Login component -->
    <p class="body-text text-align-center registration-warning">
      <span>Don’t have an account yet? </span>
      <router-link class="simple-link" to="/sign-up">Register here</router-link>
    </p>

    <h1 class="heading h1 text-align-center page-title">
      Login into your Augmentify account
    </h1>


    <n-text type="error" v-if="authLoginStore.errors?.message === 'Unauthorized'" class="error-message text-center">
      Incorrect email or password
    </n-text>

    <div class="form-wrapper">
      <n-form ref="formRef" :model="formData" :rules="loginRules">
        <div class="input-group">
          <n-form-item path="email" label="Email" :feedback="errorMessage(authLoginStore.status, 'email')" :validation-status="validationStatus(authLoginStore.status)">
            <n-input v-model:value="formData.email" size="large" round placeholder="Yourname@email.com" class="form-input" @keydown.enter.prevent />
          </n-form-item>

          <n-form-item path="password" label="Password" :feedback="errorMessage(authLoginStore.status, 'password')" :validation-status="validationStatus(authLoginStore.status)">
            <n-input v-model:value="formData.password" size="large" round placeholder="Password" class="form-input" type="password" show-password-on="click" />
          </n-form-item>
        </div>

        <div class="forgot-password-container">
          <a class="secondary-link"> Forgot password? </a>
        </div>

        <n-button class="button" size="large" @click.prevent="handleLogin" :loading="authLoginStore.status === 0">
          LOGIN
        </n-button>
      </n-form>
    </div>

<!--    <n-divider>or</n-divider>-->

<!--    <n-button class="button" size="large" disabled>-->
<!--      <template #icon>-->
<!--        <n-icon>-->
<!--          <google-icon class="icon-full" style="width: 100%; height: auto;" />-->
<!--        </n-icon>-->
<!--      </template>-->
<!--      Continue with Google-->
<!--    </n-button>-->
  </div>
</template>

<style lang="scss">
.error-message {
  margin: 10px 0;
  display: block;
}
</style>